// extracted by mini-css-extract-plugin
export default {"container":"indicators_container__xB0jE","col":"indicators_col__nsQQx","title":"indicators_title__5AHzd","subtitle":"indicators_subtitle__WtEL0"};